"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.getRewardSearchOptions = exports.formatRewardsData = exports.formatRewardData = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));

var _olyEngineUtils = require("@sportheroes/oly-engine-utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var formatRewardData = function formatRewardData(rewardData, settings) {
  var _ref = settings || {},
      _ref$language = _ref.language,
      language = _ref$language === void 0 ? 'en' : _ref$language,
      _ref$defaultLanguage = _ref.defaultLanguage,
      defaultLanguage = _ref$defaultLanguage === void 0 ? 'en' : _ref$defaultLanguage;

  if (!rewardData) {
    return null;
  }

  if (!rewardData.display) {
    return rewardData;
  }

  var displayRewardsKeys = Object.keys(rewardData.display);
  var formatedReward = displayRewardsKeys.reduce(function (rewardData, currentKey) {
    return _objectSpread({}, rewardData, (0, _defineProperty2["default"])({}, currentKey, _olyEngineUtils.displayUtils.getOneDisplayValue({
      key: currentKey,
      display: rewardData.display,
      language: language,
      defaultLanguage: defaultLanguage,
      rootObject: rewardData
    })));
  }, rewardData);
  return formatedReward;
};

exports.formatRewardData = formatRewardData;

var formatRewardsData = function formatRewardsData(rewardsData, settings) {
  if (!rewardsData) {
    return {
      hits: undefined,
      nbHits: undefined,
      nbPages: undefined,
      page: undefined
    };
  }

  var rewardsHits = rewardsData.hits && rewardsData.hits.map(function (reward) {
    return reward.display ? formatRewardData(reward, settings) : reward;
  });
  return _objectSpread({}, rewardsData, {
    hits: rewardsHits
  });
};

exports.formatRewardsData = formatRewardsData;

var getRewardSearchOptions = function getRewardSearchOptions(searchOptions, filters) {
  var _ref2 = filters || {},
      _ref2$available = _ref2.available,
      available = _ref2$available === void 0 ? true : _ref2$available,
      category = _ref2.category,
      clientId = _ref2.clientId;

  var availableFilter = available ? 'available' : null;
  var categoryFilter = category ? "categories:".concat(category) : null;
  var legacyFilters = ['NOT challenge', 'NOT charity'];
  var finalFilters = [availableFilter, categoryFilter].concat(legacyFilters).filter(function (v) {
    return v;
  }).join(' AND ');
  return _objectSpread({}, searchOptions, {
    filters: finalFilters,
    facetFilters: clientId ? ["clients:".concat(clientId)] : []
  });
};

exports.getRewardSearchOptions = getRewardSearchOptions;
var _default = {
  formatRewardData: formatRewardData,
  formatRewardsData: formatRewardsData,
  getRewardSearchOptions: getRewardSearchOptions
};
exports["default"] = _default;
//# sourceMappingURL=utils.js.map